import { Card, Flex, Button, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { documentExtractionInfoContainer } from "../../styles_vanilla.css";
import { DOCUMENT_EXTRACTION_INFO_CARD_CONFIG, DocumentExtractionInfoCardType } from "./config";

type DocumentExtractionInfoCardProps = {
  config: { key: DocumentExtractionInfoCardType; onClick?: (() => void) | null };
  differenceCount: number;
  readonly: boolean;
};
export const DocumentExtractionInfoCard = ({
  config,
  differenceCount,
  readonly,
}: DocumentExtractionInfoCardProps) => {
  const { cardTitle, cardContent, buttonContent } =
    DOCUMENT_EXTRACTION_INFO_CARD_CONFIG[config.key];

  const resolvedCardTitle =
    typeof cardTitle === "function" ? cardTitle({ differenceCount }) : cardTitle;
  const resolvedButtonContent =
    buttonContent &&
    (typeof buttonContent === "function" ? buttonContent({ differenceCount }) : buttonContent);

  return (
    <Card className={documentExtractionInfoContainer} variant="neutral">
      <Flex flexDirection="column" gap={8}>
        <Flex flexDirection="row" alignItems="center" gap={8}>
          <Icon type="regular-file-sparkle" />
          <Text variant="strong-md">{resolvedCardTitle}</Text>
        </Flex>
        <Text variant="regular-md">{cardContent}</Text>
        {config.onClick && resolvedButtonContent && (
          <Button disabled={readonly} onClick={config.onClick}>
            {resolvedButtonContent}
          </Button>
        )}
        <Text variant="regular-sm">
          Suggestions are based on data extracted by AI. Please verify important details.
        </Text>
      </Flex>
    </Card>
  );
};
